"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuggestionContainerStyle = exports.RailItemsStyle = exports.RailContainerStyle = exports.IntegrationRailContainerStyle = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _shared = require("../../shared");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const rightPositionCss = (0, _styledComponents.css)(["right:0;top:0;"]);
const leftPositionCss = (0, _styledComponents.css)(["left:0;top:0;"]);
const positionMap = new Map();
positionMap.set('right', rightPositionCss);
positionMap.set('left', leftPositionCss);

const RailContainerStyle = _styledComponents.default.div.withConfig({
  displayName: "styles__RailContainerStyle",
  componentId: "sc-kg3kas-0"
})(["background:", ";width:", ";height:", ";position:absolute;display:flex;flex-direction:column;align-items:center;justify-content:space-between;flex:1;", ";padding:30px 20px;box-sizing:border-box;"], _shared.theme.palette.brand.primary.white, ({
  width
}) => width, ({
  height
}) => height, ({
  position
}) => position && `${positionMap.get(position)}`);

exports.RailContainerStyle = RailContainerStyle;

const RailItemsStyle = _styledComponents.default.div.withConfig({
  displayName: "styles__RailItemsStyle",
  componentId: "sc-kg3kas-1"
})(["display:flex;flex-direction:column;align-items:center;justify-content:flex-start;flex:1;.flot-tile{position:fixed;bottom:30px;}"]);

exports.RailItemsStyle = RailItemsStyle;
const IntegrationRailContainerStyle = (0, _styledComponents.default)(RailContainerStyle).withConfig({
  displayName: "styles__IntegrationRailContainerStyle",
  componentId: "sc-kg3kas-2"
})(["width:336px;height:100%;z-index:", ";justify-content:flex-start;align-items:flex-start;", " ", ";padding:50px 32px;overflow-y:auto;.integration-content-container{margin-top:50px;display:flex;flex-direction:column;width:100%;label{", ";color:", ";margin-bottom:29px;}}"], _shared.theme.zIndex.rail, _shared.theme.shadows.light.level1, ({
  position
}) => position && `${positionMap.get(position)}`, _shared.theme.typography.kicker, _shared.theme.palette.brand.primary.gray);
exports.IntegrationRailContainerStyle = IntegrationRailContainerStyle;

const SuggestionContainerStyle = _styledComponents.default.div.withConfig({
  displayName: "styles__SuggestionContainerStyle",
  componentId: "sc-kg3kas-3"
})(["display:flex;justify-content:space-between;align-items:center;color:", ";button{border:solid 1px ", ";padding:8px 14px;height:32px;&:focus{border:1px solid ", ";}}"], _shared.theme.palette.ui.neutral.grey1, _shared.theme.palette.brand.primary.charcoal, _shared.theme.palette.brand.primary.charcoal);

exports.SuggestionContainerStyle = SuggestionContainerStyle;